import { render, staticRenderFns } from "./DraggableSort.vue?vue&type=template&id=00af5799"
import script from "./DraggableSort.vue?vue&type=script&lang=js"
export * from "./DraggableSort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports